const RequireAuth = ({ children }) => {
    //return <Navigate to="/error/403" state={{ from: location }} replace />;
    return children;
}

export default RequireAuth
